export type DeviceSizeMapType = {
  [key_size: string]: string;
};

export const DeviceSizeOrder: string[] = [
  'mobileS',
  'mobileM',
  'mobileL',
  'tablet',
  'laptop',
  'laptopL',
  'desktop',
  'desktopL',
];

export const DeviceSizeMap: DeviceSizeMapType = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
  desktopL: '3328px',
};

export const IsMobileWidth = (width: number | undefined): boolean => {
  if (!width) {
    return false;
  }
  return width <= Number(DeviceSizeMap.mobileL.substring(0, 3));
};

const DeviceSizes = {
  mobileS: `screen and (min-width: ${DeviceSizeMap.mobileS})`,
  mobileM: `screen and (min-width: ${DeviceSizeMap.mobileM})`,
  mobileL: `screen and (min-width: ${DeviceSizeMap.mobileL})`,
  tablet: `screen and (min-width: ${DeviceSizeMap.tablet})`,
  laptop: `screen and (min-width: ${DeviceSizeMap.laptop})`,
  laptopL: `screen and (min-width: ${DeviceSizeMap.laptopL})`,
  desktop: `screen and (min-width: ${DeviceSizeMap.desktop})`,
  desktopL: `screen and (min-width: ${DeviceSizeMap.desktopL})`,
};

export const widthToWindowSizeName = (
  width: number,
  windowSizeMap: DeviceSizeMapType
): string => {
  const keys = Object.keys(windowSizeMap);
  // eslint-disable-next-line
  for (const [index, key] of keys.entries()) {
    const widthForSize = Number(
      windowSizeMap[key].substring(0, windowSizeMap[key].length - 2)
    );
    if (index === 0 && width <= widthForSize) {
      return key;
    }
    if (index > 0) {
      const pastKey = keys[index - 1];
      const pastWidthForSize = Number(
        windowSizeMap[pastKey].substring(0, windowSizeMap[pastKey].length - 2)
      );
      if (width >= pastWidthForSize && width < widthForSize) {
        return pastKey;
      }
    }
  }
  return keys[keys.length - 1];
};

export default DeviceSizes;
